import styled from 'styled-components'

export const StyledProgressContainer = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
	margin-left: 10px;
`

export const StyledProgressBar = styled.div`
	background-color: rgb(233, 233, 233);
	border-radius: 0.5rem;
	height: 14px;
	min-width: ${({ width }) => width + 'px'};
	width: ${({ width }) => width + 'px'};
	overflow: hidden;
	& .progress {
		background-color: ${({ theme }) => theme.greenColor};
		width: ${({ progress }) => progress + '%'};
		border-radius: 1rem;
		height: 100%;
		position: relative;
		transition: width 0.3s ease-in-out;
		&:before {
			content: '${({ progress }) => progress > 19 ? progress + '%' : ''}';
			font-weight: bold;
			font-size: 0.7em;
			color: ${({ theme }) => theme.darkbgColor};
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
			right: 3px;
		}
		&:after {
			content: "";
			position: absolute;
			top: 0; left: 0; bottom: 0; right: 0;
			background-image: repeating-linear-gradient(-45deg, rgba(255, 255, 255, .15), rgba(255, 255, 255, .15) 3px, transparent 3px, transparent 6px);
			z-index: 1;
			background-size: 500px 500px;
			animation: move 6s linear infinite reverse;
			overflow: hidden;
		}
	}
	@keyframes move {
		0% {background-position: 0 0;}
		100% {background-position: 50px 50px;}
	}
`
